export default {
  // Errors
  TransportDateMustBeAfterDeliveryDate: 'تاریخ حمل و نقل باید بعد از تاریخ تحویل باشد',
  insufficientStock: 'Insufficient stock',

  // Words
  actualWeight: 'وزن خالص',
  address: 'آدرس',
  addTransportLicense: 'افزودن مجوز حمل',
  allowedUnloadTime: 'ساعت مجاز تخلیه',
  allowedUnloadTimeFrom: 'ساعت مجاز تخلیه (از ساعت)',
  allowedUnloadTimeTo: 'ساعت مجاز تخلیه (تا ساعت)',
  bundleCount: 'تعداد بسته',
  buyerName: 'نام خریدار',
  cargoRow: 'ردیف باربری',
  carInfo: 'اطلاعات وسیله',
  city: 'شهر',
  date: 'تاریخ',
  deliveryInfo: 'اطلاعات تحویل دهنده',
  disciplinaryNumber: 'شماره انتظامی',
  driverInfo: 'مشخصات راننده',
  emptyWeighingHours: 'ساعت توزین وزن خالی',
  emptyWeighingMinutes: 'دقیقه توزین وزن خالی',
  emptyWeight: 'وزن خالی',
  from: 'از ساعت',
  fromDate: 'از تاریخ',
  fullWeighingHours: 'ساعت توزین وزن پر',
  fullWeighingMinutes: 'دقیقه توزین وزن پر',
  fullWeight: 'وزن پر',
  inventorySignature: 'امضا و مهر انبار',
  iran: 'ایران',
  issuePlace: 'محل صدور',
  licenseNumber: 'شماره گواهینامه',
  licenseValidity: 'اعتبار مجوز',
  loadingPlaceInfo: 'اطلاعات محل بارگیری',
  personalTransport: 'حمل شخصی',
  preNumber: 'پیش شماره',
  productDescription: 'شرح کالا',
  province: 'استان',
  recipientCellNumber: 'شماره همراه تحویل گیرنده',
  recipientDescription: 'کالای شرح داده شده در بالا، بدون عیب و نقص بصورت امانت تحویل اینجانب شده و اینجانب موظف به تحویل کالا به خریدار فوق بوده و رسید آن را تحویل شرکت حمل و نقل خواهد شد.',
  recipientInfo: 'اطلاعات تحویل گیرنده',
  recipientName: 'نام تحویل گیرنده',
  recipientNationalCode: 'کد ملی تحویل گیرنده',
  recipientPhoneNumber: 'شماره تلفن ثابت تحویل گیرنده',
  recipientPrePhoneNumber: 'پیش شماره تلفن ثابت تحویل گیرنده',
  recipientSignature: 'امضا و اثر انگشت راننده',
  requestAmount: 'مقدار درخواست',
  requestSubmissionDate: 'تاریخ ثبت درخواست',
  smartNumber: 'شماره هوشمند',
  to: 'تا ساعت',
  toDate: 'تا تاریخ',
  trailerName: 'نام بارگیر',
  transport: 'حمل و نقل',
  transportCompanyInfo: 'اطلاعات شرکت حمل و نقل',
  transportRequest: 'درخواست حمل و نقل',
  transportRequestDetails: 'جزئیات درخواست حمل و نقل شماره {number}',
  transportRequests: 'درخواست های حمل و نقل',
  transportRequestSubmitted: 'درخواست حمل و نقل ثبت شد',
  transportByCourier: 'حمل و نقل توسط {courier}',
  transportDate: 'تاریخ حمل و نقل',
  transportDone: 'حمل و نقل انجام شد',
  transporterCellNumber: 'شماره همراه حمل کننده',
  transporterFirstName: 'نام حمل کننده',
  transporterInfo: 'اطلاعات حمل کننده',
  transporterLastName: 'نام خانوادگی حمل کننده',
  transporterNationalCode: 'کد ملی حمل کننده',
  transporterPhoneNumber: 'شماره تلفن ثابت حمل کننده',
  transporterPrePhoneNumber: 'پیش شماره تلفن ثابت حمل کننده',
  transportLicense: 'مجوز حمل',
  transportLicenses: 'مجوزهای حمل',
  transportLicenseSaved: 'مجوز حمل ذخیره شد',
  transportRecord: 'صورت جلسه تحویل',
  transportRecordSaved: 'صورت جلسه تحویل دخیره شد',
  transportRequestOf: 'درخواست حمل و نقل',
  transportType: 'نوع حمل و نقل',
  unloadPlace: 'اطلاعات محل تخلیه',
  unloadPlaceName: 'نام محل تخلیه',
  unloadTime: 'ساعت تخلیه',
  weighbridgeReceipt: 'شماره قبض باسکول',
  weighingHour: 'ساعت توزین',
  weighingInfo: 'اطلاعات توزین',
  zipCode: 'کد پستی',
  licenseRecord: 'صورت جلسه تحویل',
  statuses: {
    tranporting: 'در حال حمل',
    transported: 'حمل شده'
  }
}
